import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollReveal from '@/components/base/ScrollReveal';
import CountUp from '@/components/base/CountUp';
import ParticleBackground from '@/components/base/ParticleBackground';
import { Link } from 'react-router-dom';

const businesses = [
  {
    id: 'asset',
    icon: 'ri-database-2-line',
    title: '县域文化数字资产库建设',
    subtitle: '文化资源 · 系统归档 · 云端复用',
    definition: '面向县域政府及文旅单位，提供历史文化传说、非遗技艺、古建文物、文旅地标、民俗风情等文化资源的系统化采集、数字化归档、云存储管理与多场景复用服务。',
    values: ['文化资源永久保存，防止遗失', '一次采集，多元创作复用', '为AI内容生产提供底层数据支撑', '助力地方文化数字化转型升级'],
    services: ['文化资源田野调查与采集', '数字资产标准化归档处理', '云端数据库搭建与运维', '资产检索与复用接口开发', '定期更新与版本迭代'],
    scenarios: ['县域政府文化数字化建设', '非遗保护与传承项目', '地方文旅资源整合', '文化大数据平台建设'],
    highlight: { prefix: '已建成山西', number: 117, suffix: '个县域文化数字资产库1.0' },
  },
  {
    id: 'aigc',
    icon: 'ri-movie-line',
    title: 'AIGC漫剧/仿真人短剧定制生产',
    subtitle: 'AI驱动 · 工业化量产 · 月产千集',
    definition: '基于自研AI工业化SOP生产标准平台，提供从剧本创作、分镜设计、AI绘画、仿真人制作到剪辑配音、成片输出的全流程AI短剧/漫剧定制生产服务。',
    values: ['月产千集级工业化量产能力', '标准化品控体系，品质稳定', '大幅降低内容生产成本', '支持多题材、多风格定制'],
    services: ['AI剧本智能创作与优化', 'AI分镜设计与场景生成', 'AI角色绘画与仿真人制作', '智能配音与音效合成', '成片剪辑与后期包装'],
    scenarios: ['文旅宣传漫剧定制', '品牌故事短剧创作', '红色主旋律内容生产', '知识科普动画制作'],
    highlight: { prefix: '已推出', number: 100, suffix: '部精品AI漫剧，覆盖知乎、红果、火山等平台' },
  },
  {
    id: 'ip',
    icon: 'ri-lightbulb-flash-line',
    title: '城市文旅IP孵化与数字内容宣发',
    subtitle: '全案孵化 · IP破圈 · 全媒体传播',
    definition: '为城市、县域、景区提供从0到1的文旅IP全案孵化服务，涵盖IP定位、文化提炼、视觉体系、内容矩阵搭建到全媒体宣发的一站式解决方案。',
    values: ['从0到1全案孵化能力', '深度文化提炼与创意表达', '全媒体矩阵传播资源', '数据驱动的效果评估'],
    services: ['IP定位与文化内核提炼', '视觉识别体系设计', '内容矩阵策略与生产', '全媒体渠道宣发投放', 'IP授权与商业衍生'],
    scenarios: ['城市文旅品牌升级', '县域文化IP打造', '景区数字内容营销', '文旅节事活动推广'],
    highlight: { prefix: '多地县域专属文旅内容矩阵打造', number: 0, suffix: '' },
  },
  {
    id: 'brand',
    icon: 'ri-store-3-line',
    title: '品牌文化赋能与流量电商运营',
    subtitle: '品牌升级 · 内容定制 · 电商转化',
    definition: '将地域文化与品牌升级深度融合，提供品牌IP塑造、品牌故事定制、TVC广告制作、短视频运营、直播带货、电商转化等全链路品牌赋能服务。',
    values: ['文化赋能品牌差异化', '内容驱动流量增长', '直播电商高效转化', '全链路运营托管'],
    services: ['品牌文化IP塑造', '品牌故事与TVC定制', '短视频内容矩阵运营', '直播间搭建与代运营', '电商店铺管理与招商'],
    scenarios: ['地域特色品牌升级', '老字号品牌年轻化', '新消费品牌文化赋能', '农产品品牌化运营'],
    highlight: { prefix: '标杆案例：', number: 0, suffix: '舌尖味道品牌全国独家运营战略合作伙伴' },
  },
  {
    id: 'opc',
    icon: 'ri-user-star-line',
    title: 'OPC超级个体孵化与创作者生态培育',
    subtitle: '一人公司 · 联盟协同 · 实战孵化',
    definition: '依托冯全普·县域AI+OPC联盟OPC模式，面向返乡青年、高校毕业生、影视从业者与文旅创作者，构建“AI工具+标准化SOP+专业服务中台+实战项目”四位一体孵化体系。',
    values: ['帮助个体从会用AI到可承接项目', '覆盖创作、制作、运营、译制全链条', '形成人才培养到商业变现闭环', '支撑县域数字内容产业持续发展'],
    services: ['AI编剧与分镜实训', 'AI绘画与仿真人制作训练', '后期剪辑配音与账号运营指导', '跨境译制与多语内容交付', '项目制孵化与商业订单对接'],
    scenarios: ['OPC社区人才孵化', '院校创作者就业创业', '县域内容创业项目', '联盟跨区域项目协同交付'],
    highlight: { prefix: '联盟协同：', number: 0, suffix: '“一个人+AI，激活一城产业；一个社区，孵化一批超级个体”' },
  },
];

export default function Business() {
  return (
    <div className="ui-page">
      <Navbar />
      <main className="pt-20">
        <section className="relative py-20 md:py-28 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-background-900/40 to-transparent z-[1]"></div>
          <ParticleBackground compact />
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
            <div className="max-w-screen-2xl mx-auto">
              <ScrollReveal>
                <div className="text-center mb-16">
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-6">
                    <span className="w-1 h-1 rounded-full bg-primary-500"></span>
                    <span className="text-primary-300 text-xs font-medium tracking-wider whitespace-nowrap">Our Business</span>
                  </div>
                  <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-primary-500 mb-6">核心业务</h1>
                  <p className="text-secondary-400 text-lg max-w-2xl mx-auto">五大业务板块，构建文化数字化全链路商业闭环</p>
                </div>
              </ScrollReveal>

              <div className="space-y-16">
                {businesses.map((biz, index) => (
                  <ScrollReveal key={biz.id}>
                    <section id={biz.id} className={`group scroll-mt-24 rounded-2xl ${index % 2 === 1 ? 'bg-background-900/50 -mx-4 md:-mx-8 lg:-mx-12 px-4 md:px-8 lg:px-12 py-12 md:py-16' : 'border border-primary-500/10 p-8 md:p-12 hover:border-primary-500/25 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.1)]'}`}>
                      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                        <div className="lg:col-span-1">
                          <div className="w-14 h-14 rounded-xl bg-primary-500/10 flex items-center justify-center mb-5 group-hover:bg-primary-500/20 group-hover:scale-110 transition-all duration-500">
                            <i className={`${biz.icon} text-primary-500 text-2xl`}></i>
                          </div>
                          <div className="inline-block px-3 py-1 rounded-full bg-accent-500/15 border border-accent-500/20 text-accent-300 text-xs font-medium mb-4 whitespace-nowrap">
                            {biz.subtitle}
                          </div>
                          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-4 group-hover:text-primary-500 transition-colors duration-500">{biz.title}</h2>
                          <p className="text-secondary-400 text-sm leading-relaxed mb-6">{biz.definition}</p>
                          <div className="py-3 px-4 bg-primary-500/5 rounded-lg border border-primary-500/10 group-hover:border-primary-500/25 transition-all duration-500">
                            <p className="text-primary-400 text-xs font-medium">
                              {biz.highlight.prefix}
                              {biz.highlight.number > 0 && <><CountUp end={biz.highlight.number} duration={2000} />{biz.highlight.suffix}</>}
                              {biz.highlight.number === 0 && biz.highlight.suffix}
                            </p>
                          </div>
                        </div>

                        <div className="lg:col-span-2">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                              <h4 className="text-foreground-50 font-semibold text-sm mb-3">核心价值</h4>
                              <ul className="space-y-2">
                                {biz.values.map((v) => (
                                  <li key={v} className="flex items-start gap-2 text-secondary-400 text-sm">
                                    <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                                      <i className="ri-check-line text-primary-500 text-xs"></i>
                                    </div>
                                    {v}
                                  </li>
                                ))}
                              </ul>
                            </div>
                            <div>
                              <h4 className="text-foreground-50 font-semibold text-sm mb-3">服务内容</h4>
                              <ul className="space-y-2">
                                {biz.services.map((s) => (
                                  <li key={s} className="flex items-start gap-2 text-secondary-400 text-sm">
                                    <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                                      <i className="ri-arrow-right-s-line text-primary-500 text-xs"></i>
                                    </div>
                                    {s}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                          <div className="mt-6">
                            <h4 className="text-foreground-50 font-semibold text-sm mb-3">应用场景</h4>
                            <div className="flex flex-wrap gap-2">
                              {biz.scenarios.map((s) => (
                                <span key={s} className="px-3 py-1.5 rounded-full bg-secondary-500/10 border border-secondary-500/15 text-secondary-400 text-xs whitespace-nowrap hover:bg-secondary-500/20 hover:text-secondary-300 transition-all duration-300 cursor-default">
                                  {s}
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-8 flex gap-4">
                        <Link to="/cooperation" className="group/btn inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-foreground-50 font-medium rounded-full text-sm hover:bg-accent-400 transition-all duration-300 whitespace-nowrap cursor-pointer">
                          立即咨询
                          <div className="w-4 h-4 flex items-center justify-center transition-transform duration-300 group-hover/btn:translate-x-1">
                            <i className="ri-arrow-right-line"></i>
                          </div>
                        </Link>
                        <Link to="/contact" className="group/btn inline-flex items-center gap-2 px-6 py-3 border border-primary-500/50 text-primary-500 font-medium rounded-full text-sm hover:bg-primary-500/10 transition-all duration-300 whitespace-nowrap cursor-pointer">
                          获取方案
                          <div className="w-4 h-4 flex items-center justify-center transition-transform duration-300 group-hover/btn:translate-x-1">
                            <i className="ri-arrow-right-line"></i>
                          </div>
                        </Link>
                      </div>
                    </section>
                  </ScrollReveal>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
